<template>
  <div>
    <div v-if="loading" class="text-xs-center"></div>
    <div v-else-if="!data" class="text-xs-center">
      <v-icon x-large>highlight_off</v-icon>
      <div>Not found video</div>
    </div>
    <template v-else>
      <slot v-bind="{ url: url }"> </slot>
    </template>
  </div>
</template>

<script>
// import api from '@/api'
// import axios from 'axios'
import config from '@/config'
export default {
  props: ['value', 'pageid'],
  data() {
    return {
      loading: true,
      data: null,
      binary: null,
      url: ''
    }
  },
  async mounted() {
    this.loading = true
    this.data = JSON.parse(this.value)
    if (this.data.type == 'video' && this.data.id) {
      this.url = config.serverUrl + `line/content/video/${this.pageid}/${this.data.id}`
    }
    try {
      // this.data = JSON.parse(this.value)
      // if(this.data.type == 'video' && this.data.id){
      //   let url = config.serverUrl + `line/content/video/${this.pageid}/${this.data.id}`
      // var response = await axios
      //   .get(url, {  headers: {
      //     'api-key': '1-2-3-sharks-landed'
      //   }})
      // }
      // if(response.status == 200 && response.data.success && response.data.result) {
      //   console.log(response.data)
      //   this.binary = response.data.
      // }
    } catch (error) {
      console.error(error)
    } finally {
      this.loading = false
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/LineContentVideo.vue